<!-- TVG-344: every consent this contact has given or changed, with when, where
     and the exact wording. Above it, the wording staff read out on a phone call
     before ticking a box, and whether a text to this contact would be refused. -->
<div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]" data-testid="contact-consent-history">
  <div class="px-5 py-4 sm:px-6 sm:py-5">
    <h3 class="text-base font-medium text-gray-800 dark:text-white/90">Consent history</h3>
  </div>

  <div class="space-y-4 border-t border-gray-100 p-5 dark:border-gray-800 sm:p-6">
    @if (loadError) {
      <div class="rounded-md bg-error-50 p-3 text-theme-sm text-error-700">{{ loadError }}</div>
    }

    @if (textCheck) {
      <div
        data-testid="contact-text-check"
        class="rounded-lg border px-3 py-2 text-theme-sm"
        [ngClass]="textCheck.allowed
          ? 'border-green-200 bg-green-50/70 text-green-700 dark:border-green-500/30 dark:bg-green-500/10 dark:text-green-300'
          : 'border-amber-200 bg-amber-50/70 text-amber-700 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300'">
        @if (textCheck.allowed) {
          Texts allowed: this contact has a phone number and has given text consent.
        } @else {
          A text to this contact would be refused. {{ textCheck.reason }}
        }
      </div>
    }

    @if (phoneWording.length > 0) {
      <details class="rounded-lg border border-gray-200 px-3 py-2 dark:border-gray-800" data-testid="contact-phone-wording">
        <summary class="cursor-pointer text-theme-sm font-medium text-gray-700 dark:text-gray-300">
          Taking consent by phone? Read this out, then tick the box under Permissions and save
        </summary>
        <dl class="mt-3 space-y-2 text-theme-sm">
          @for (item of phoneWording; track item.permission) {
            <div>
              <dt class="text-theme-xs text-gray-500 dark:text-gray-400">{{ item.label }}</dt>
              <dd class="text-gray-700 dark:text-gray-300">{{ item.wording || 'No wording set' }}</dd>
            </div>
          }
        </dl>
      </details>
    }

    @if (records.length > 0) {
      <div class="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800">
        <table class="w-full text-left text-theme-sm">
          <thead class="bg-gray-100 text-theme-xs text-gray-500 dark:bg-white/[0.04] dark:text-gray-400">
            <tr>
              <th class="px-4 py-2.5 font-medium">When</th>
              <th class="px-4 py-2.5 font-medium">Permission</th>
              <th class="px-4 py-2.5 font-medium">Consent</th>
              <th class="px-4 py-2.5 font-medium">Where</th>
              <th class="px-4 py-2.5 font-medium">Wording</th>
              <th class="px-4 py-2.5 font-medium">Recorded by</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
            @for (record of records; track record.id) {
              <tr class="text-gray-700 dark:text-gray-300" data-testid="consent-record-row">
                <td class="px-4 py-2.5 whitespace-nowrap">{{ record.recorded_at | date: 'EEE d MMM yyyy, HH:mm' }}</td>
                <td class="px-4 py-2.5">{{ record.permission_label }}</td>
                <td class="px-4 py-2.5">
                  <span
                    class="inline-flex items-center rounded-full px-2.5 py-1 text-theme-xs font-medium"
                    [ngClass]="record.granted
                      ? 'bg-green-50 text-green-700 dark:bg-green-500/15 dark:text-green-300'
                      : 'bg-gray-100 text-gray-600 dark:bg-white/5 dark:text-white/70'">
                    {{ record.granted ? 'Given' : 'Withdrawn' }}
                  </span>
                </td>
                <td class="px-4 py-2.5">{{ record.source_label }}</td>
                <td class="px-4 py-2.5">{{ record.wording || '—' }}</td>
                <td class="px-4 py-2.5">{{ record.recorded_by?.name || '—' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else if (!loading && !loadError) {
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">No consent has been recorded for this contact yet.</p>
    }

    @if (loading) {
      <p class="text-theme-sm text-gray-500 dark:text-gray-400">Loading consent history…</p>
    }
  </div>
</div>
